/* oxlint-disable typescript/no-unused-vars */
import { ca } from '@cian/analytics';

import { INewReviewsSecondStepOpen } from '../../types/newReview/analytics';
import { TUserAnalytics } from '../../types/currentUser';

export function trackNewReviewSubmit({
  siteType,
  rating,
  ratings,
  review_status,
  pros,
  cons,
  is_anonymous,
  is_name_entered,
  user,
}: {
  siteType: string;
  rating: number;
  ratings: INewReviewsSecondStepOpen;
  review_status: string;
  pros: string;
  cons: string;
  is_anonymous: boolean;
  is_name_entered: boolean;
  user: TUserAnalytics;
}) {
  return ca('eventSite', {
    name: 'oldevent',
    category: 'NewbuildingReviews',
    action: 'Success',
    label: 'Review_Submit',
    useLastProducts: true,
    page: {
      offerType: 'JK',
      pageType: 'ReviewsJK',
      siteType,
      extra: {
        rating,
        ratings,
        review_status,
        pros,
        cons,
        is_anonymous,
        is_name_entered,
      },
    },
  });
}
